/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined, UploadOutlined, UserOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import './index.less';
import 'whatwg-fetch';

/**
 * 独立组件
 * 
 * 开发说明：封装独立的组件，在该index.jsx中import引入
 * **/
import Doc from './doc';
import Input from './input';
import Job from './job';
import Qa from './q&a';
import Report from './report';

// 页尾部分
import Footer from '../layout/Footer';
import { FooterDataSource } from '../layout/data.source.js';

const { Header, Sider, Content } = Layout;

export default class G2G extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active: 'doc',
      tutorial_markdown: '',
      about_markdown: '',
      collapsed: false,
      current: '1'
    };
  }

  componentWillMount() {

  }

  componentDidMount() {
    this.setState({ loading: true });

    /**
     * 接口请求demo
     * 
     * 开发说明：后端IP不要写在每一个文件中，统一抽离一个文件配置开发环境、测试环境、线上环境对应的服务器IP地址（写一遍即可，方便修改）
     * **/
    fetch("https://jsonplaceholder.typicode.com/users")
      .then(response => {
        /**
         * 这个response是服务器返回的可读数据流，内部存储的是二进制数据
         * .json()的作用，就是读取response这个二进制数据流，并把读取到的数据,转为JSON格式的Promise对象
         * **/ 
        return response.json();
      })
      .then(data => {
        // 这里第二个.then中拿到的data, 就是接口返回最终的数据
        console.log('接口返回数据 =>', data);
      })
      .catch(err => {
        // 如果接口请求失败，捕获异常（切记开发时要考虑到特殊情况，增加兜底逻辑）
        console.error(err);
      })

    const{ history, location } = this.props;
    const { search } = location;

    if(search === ''){
      history.push({
        pathname: location.pathname,
        search: 'type=input'
      });
    } else {
      const type = search.replace('?type=', '');
      this.setState({
        active: type || 'input'
      });
    }

    // 接口请求
    const iframe = this.refs.Iframe;

    if (iframe) {
      // 兼容处理
      if (iframe.attachEvent) {
        // IE
        iframe && iframe.attachEvent("onload", () => {
          this.setState({
            loading: false
          });
        });
      } else {
        // 非IE
        iframe.onload = () => {
          this.setState({
            loading: false
          });
        };
      }
    }
  };

  // 样例代码
  updateSearch(targetKey,targetValue) {
    const { location } = this.props;
    const { search } = location;
    let queryStr = search.slice(1);
    let queryArr = queryStr.split('&');
    let targetIndex = -1;

    queryArr.forEach((item,i) => {
      let key = item.split('=')[0];
      if(key === targetKey){
        targetIndex = i;
      }
    });

    //如果查找不到name，返回原始search
    if(targetIndex === -1){
      return search;
    }
    
    let targetArr = queryArr[targetIndex].split('=');
    targetArr[1] = targetValue;
    queryArr[targetIndex] = targetArr.join('=');
    return queryArr.join('&');
  }

  render() {
    const { collapsed, current } = this.state;

    const overview = () => {
      if (current === '1') {
        return (
          <div>
            Overview页面，该处引入Overview对应组件
          </div>
        )
      } else if (current === '2') {
        return (
          <div>
            Input页面，该处引入Input对应组件
          </div>
        )
      } else if (current === '3') {
        return (
          <div>
            MyJob页面，该处引入MyJob对应组件
          </div>
        )
      } else {
        return (
          <div>
            Q&A页面，该处引入Q&A对应组件
          </div>
        )
      }
    };
    
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        <Layout className="g2g-page">
          <Sider trigger={null} collapsible collapsed={collapsed}>
            <div className="logo" />
            <div className="menu-image">
              <img src="/assets/images/home-meta.png" alt="G2G 导航背景"/>
            </div>
            <Menu
              theme="dark"
              mode="inline"
              defaultSelectedKeys={['1']}
              selectedKeys={[current]}
              onClick={(e) => this.setState({
                current: e.key || '1'
              })}
              items={[
                {
                  key: '1',
                  icon: <UserOutlined />,
                  label: 'Overview',
                },
                {
                  key: '2',
                  icon: <VideoCameraOutlined />,
                  label: 'Input',
                },
                {
                  key: '3',
                  icon: <UploadOutlined />,
                  label: 'My Job',
                },
                {
                  key: '4',
                  icon: <UploadOutlined />,
                  label: 'Q & A',
                },
              ]}
            />
          </Sider>
          <Layout className="site-layout">
            <Header
              className="site-layout-background"
              style={{
                padding: 0,
              }}
            >
              {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                className: 'trigger',
                onClick: () => this.setState({
                  collapsed: !collapsed
                })
              })}
              <div className="site-header-route">
                <a href="/" alt="返回首页">返回首页</a>
              </div>
              <div className="site-header-login">
                <a href="/login" alt="登陆">登陆</a>
              </div>
            </Header>
            <Content
              className="site-layout-background"
              style={{
                margin: '24px 16px',
                padding: 24,
                minHeight: 280,
              }}
            >
              {overview()}
            </Content>
          </Layout>
        </Layout>
        <Footer 
          id="Footer"
          key="Footer"
          dataSource={FooterDataSource} 
        />
      </div>
    );
  }
}
